module.exports = __webpack_public_path__ + "static/media/Aws.6e07316c.svg";